export default {
  Title: 'Join Our Caregiver Community',
  Subtitle: 'Make a meaningful difference in people\'s lives while building a rewarding career with flexible scheduling and professional support.',
  FlexibleWork: 'Flexible Scheduling',
  FlexibleWorkDesc: 'Choose when and where you work with schedules that fit your lifestyle.',
  MeaningfulWork: 'Meaningful Impact',
  MeaningfulWorkDesc: 'Provide compassionate care that truly makes a difference in people\'s lives.',
  Community: 'Trusted Network',
  CommunityDesc: 'Join a community of vetted professionals and connect with clients who value quality care.',
  ProcessTitle: 'Simple Application Process',
  ProcessDesc: 'Complete our application form to join our network of trusted caregivers.',
  StartApplication: 'Start Your Application',
  TimeEstimate: 'Application takes approximately 15-20 minutes to complete.',
};
